import { Injectable } from '@angular/core';

export interface BuildEventNameInput {
  videoTool: string;
  hudlCategory: number | null;
  liveBroadcast: boolean;
  teamName: string;
  oppTeamName: string;
  date: Date | null;
  start: Date | null;
}

@Injectable({ providedIn: 'root' })
export class EventNameService {
  buildEventName(input: BuildEventNameInput): string {
    const { videoTool, hudlCategory, liveBroadcast, teamName, oppTeamName, date, start } = input;

    let dateStr = '';
    if (start && date) {
      const composed = new Date(start);
      composed.setFullYear(date.getFullYear());
      composed.setMonth(date.getMonth());
      composed.setDate(date.getDate());
      dateStr = `${composed.getFullYear()}-${('0' + (composed.getMonth() + 1)).slice(-2)}-${('0' + composed.getDate()).slice(-2)}`;
      if (videoTool === 'hudl' && hudlCategory !== 4) {
        dateStr += ` ${String(composed.getHours()).padStart(2, '0')}:${String(composed.getMinutes()).padStart(2, '0')}`;
      }
    }

    const parts: string[] = [];
    if (videoTool === 'hudl') {
      if (hudlCategory === 4) {
        parts.push(`${teamName} VS ${oppTeamName}`);
      } else if (hudlCategory === 6) {
        parts.push(`${oppTeamName} VS `);
      }
    } else {
      if (liveBroadcast) {
        parts.push(`${teamName} VS ${oppTeamName}`);
      } else {
        parts.push(`${teamName}`);
      }
    }

    if (dateStr) {
      parts.push(dateStr);
    }
    return parts.join(' - ');
  }

  datePrefix(date: Date): string {
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
  }
}
